import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LoadingState {
  [key: string]: boolean;
}

export enum LoadingType {
  ApplicationFetching = 'ApplicationFetching',
  ApplicationUpdating = 'ApplicationUpdating',
}

const initialState: LoadingState = {};

const loading = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    setLoadingState(state: LoadingState, { payload }: PayloadAction<{ type: string; loading: boolean }>) {
      state[payload.type] = payload.loading;
    },
  },
});

export const { setLoadingState } = loading.actions;

export default loading.reducer;
